module.exports = __webpack_public_path__ + "static/img/bri.224ee13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bri.png
// module id = ERW2
// module chunks = 1